import { render, staticRenderFns } from "./MyProfPic.vue?vue&type=template&id=29ce8246&scoped=true&"
import script from "./MyProfPic.vue?vue&type=script&lang=js&"
export * from "./MyProfPic.vue?vue&type=script&lang=js&"
import style0 from "./MyProfPic.vue?vue&type=style&index=0&id=29ce8246&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ce8246",
  null
  
)

export default component.exports